import React, { Component } from 'react';

class Checkbox extends Component {
  render() {
    const { label } = this.props;

    return (
      <label className="input-checkbox">
        <input type="checkbox" {...this.props} />
        <span>{label}</span>
      </label>
    );
  }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Form/Checkbox/index.js